export default __webpack_public_path__ + "static/media/Sigmoid_Set_up_Male_.f58068c7.png";